const NAME = "CONCEPT_GROUPS_PAGE";

export default NAME;
